<script setup>
import UserProfileComponent from "@/Components/UserCard/UserProfileComponent.vue";
import UserStatusComponent from "@/Components/UserCard/UserStatusComponent.vue";
import RatingsCategoriesComponent from "@/Components/RatingsCategories/RatingsCategoriesComponent.vue";
import ReviewersClientListComponent from "@/Components/Reviewers/ReviewersClientListComponent.vue";
import BlockPersonComponent from "@/Components/BlockPerson/BlockPersonComponent.vue";
import ClaimLimiterComponent from "@/Components/ClaimLimiter/ClaimLimiterComponent.vue";
import LicensingComponent from "@/Components/Licensing/LicensingComponent.vue";
import CertificationsComponent from "@/Components/Certifications/CertificationsComponent.vue";
import MessagesProfileMessagesComponent from "@/Components/Messaging/MessagesProfileMessagesComponent.vue";
import ClaimListComponent from "@/Components/Claims/ClaimListComponent.vue";
import ListComponent from "@/Components/Tasks/ListComponent.vue";
import NotesComponent from "@/Components/Notes/NotesComponent.vue";
import FilesUploadComponent from "@/Components/Files/FilesUploadComponent.vue";
import FilesListComponent from "@/Components/Files/FilesListComponent.vue";
import UserRequiredDocumentsComponent from "@/Components/UserCard/UserRequiredDocumentsComponent.vue";
import {useRoute} from "vue-router";
import {Permissions} from "@/Utils/Permissions";
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
const route = useRoute();

const data = reactive({
  loading: true,
  exists: false
});

const checkExists = () => {
  data.loading = true;
  data.exists = false;
  ApiWrapper.post('person', 'person-exists', {
    personId: route.params.userProfileId
  })
    .then((response) => {
      data.exists = true;
    })
    .catch((e)=>{
      data.exists = false;
    })
    .finally(()=>{
      data.loading = false;
    });

}
onMounted(() => {
  checkExists();
});

</script>

<template>
  <template v-if="data.loading">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-skeleton-loader type="card"></v-skeleton-loader>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && !data.exists">
    <v-row>
      <v-col cols="12">
        <v-container fluid>
          <v-card class="elevation-2" height="auto" width="auto">
            <v-alert title="Not Found" text="The specified user could not be found" type="error"></v-alert>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </template>

  <template v-if="!data.loading && data.exists">
    <v-container fluid>
      <v-row>
        <v-col xl="6" v-if="Permissions.checkPermissions(['users.read'])">
          <UserProfileComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
        <v-col xl="6">
          <UserStatusComponent v-if="Permissions.checkPermissions(['users.update-user-card'])" contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
          <RatingsCategoriesComponent v-if="Permissions.checkPermissions(['ratings.list'])" contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="Permissions.checkPermissions(['reviewers.list-clients'])">
          <ReviewersClientListComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col xl="8" v-if="Permissions.checkPermissions(['blocks.list'])">
          <BlockPersonComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
        <v-col xl="4" v-if="Permissions.checkPermissions(['users.read'])">
          <ClaimLimiterComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col xl="8" v-if="Permissions.checkPermissions(['licensing.list'])">
          <LicensingComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
        <v-col xl="4" v-if="Permissions.checkPermissions(['certifications.list'])">
          <CertificationsComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col xl="12" v-if="Permissions.checkPermissions(['messages.list'])">
          <MessagesProfileMessagesComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
        <v-col xl="12" v-if="Permissions.checkPermissions(['claims.list'])">
          <ClaimListComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col xl="6" v-if="Permissions.checkPermissions(['tasks.list'])">
          <ListComponent :personId="route.params.userProfileId"/>
        </v-col>
        <v-col xl="6" v-if="Permissions.checkPermissions(['notes.list'])">
          <NotesComponent :personId="route.params.userProfileId" />
        </v-col>
      </v-row>
      <v-row>
        <v-col xl="6">
          <FilesUploadComponent v-if="Permissions.checkPermissions(['files.upload'])" :personId="route.params.userProfileId"/>
          <FilesListComponent v-if="Permissions.checkPermissions(['files.list'])" :personId="route.params.userProfileId"/>
        </v-col>
        <v-col xl="6" v-if="Permissions.checkPermissions(['users.required-documents'])">
          <UserRequiredDocumentsComponent contextSchemaA="person" :contextIdA="route.params.userProfileId"/>
        </v-col>
      </v-row>
    </v-container>
  </template>
</template>

<style scoped>

</style>